import { RESET_STATE } from 'store/global/actions';

import { LOAN_APPLICATION_ACTION_TYPE } from '../actions';

const initialState = {};

const loanApplicationCommonInfoReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    // Two DISTINCT meanings, deliberately not merged into one flag:
    //   is*Loaded  = the fetch SUCCEEDED. LoanApplicationContent's validity guard (DEV-4226) redirects
    //                a non-sub-company user out of the editor when common data did not load, so a
    //                failed fetch must keep reading as "not loaded" or that guard silently dies.
    //   is*Settled = the fetch is DONE, success or failure. Consumers that would otherwise wait
    //                forever (PathToSubmission's skeleton) gate on this, so one failed request out of
    //                the loan's ~46 cannot strand them for the session.
    case LOAN_APPLICATION_ACTION_TYPE.GET_LOAN_APPLICATION_COMMON_INFO_BY_APPLICATION_ID:
      return {
        ...state,
        ...(payload || {}),
        isLoanInfoLoaded: true,
        isLoanInfoSettled: true,
        isSavingLoanApplicationChanges: false,
        isCancellingLoanApplicationChanges: false,
      };

    case LOAN_APPLICATION_ACTION_TYPE.GET_LOAN_APPLICATION_COMMON_LOCK_INFO_BY_APPLICATION_ID:
      return {
        ...state,
        ...(payload || {}),
        isLockInfoLoaded: true,
        isLockInfoSettled: true,
      };

    case LOAN_APPLICATION_ACTION_TYPE.GET_LOAN_APPLICATION_COMMON_INFO_REJECTED_STATUS:
      return {
        ...state,
        isLoanInfoSettled: true,
      };

    case LOAN_APPLICATION_ACTION_TYPE.GET_LOAN_APPLICATION_COMMON_LOCK_INFO_REJECTED_STATUS:
      return {
        ...state,
        isLockInfoSettled: true,
      };

    case LOAN_APPLICATION_ACTION_TYPE.SET_LOAN_APPLICATION_CHANNEL_INFO:
      return {
        ...state,
        ...(payload || {}),
      };

    case LOAN_APPLICATION_ACTION_TYPE.SAVE_LOAN_APPLICATION_CHANGES_PENDING_STATUS:
      return {
        ...state,
        isSavingLoanApplicationChanges: true,
      };

    case LOAN_APPLICATION_ACTION_TYPE.SAVE_LOAN_APPLICATION_CHANGES:
      return {
        ...state,
        isSavingLoanApplicationChanges: false,
      };

    case LOAN_APPLICATION_ACTION_TYPE.SAVE_LOAN_APPLICATION_CHANGES_REJECTED_STATUS:
      return {
        ...state,
        isSavingLoanApplicationChanges: false,
      };

    case LOAN_APPLICATION_ACTION_TYPE.CANCEL_LOAN_CHANGES_PENDING_STATUS:
      return {
        ...state,
        isCancellingLoanApplicationChanges: true,
      };

    case LOAN_APPLICATION_ACTION_TYPE.CANCEL_LOAN_CHANGES_REJECTED_STATUS:
      return {
        ...state,
        isCancellingLoanApplicationChanges: false,
      };

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default loanApplicationCommonInfoReducer;
